export default {
  BASE_URL: '/fm/invoice',
  api: [
    {
      name: 'recognition',
      method: 'POST',
      path: '/recognition',
      desc: '发票识别'
    },
    {
      name: 'list',
      method: 'get',
      path: '/list',
      desc: '进账发票管理列表'
    },
    {
      name: 'add',
      method: 'post',
      path: '/add',
      desc: '添加进账发票'
    },
    {
      name: 'detail',
      method: 'get',
      path: '/detail',
      desc: '进账发票明细'
    },
    {
      name: 'detailList',
      method: 'get',
      path: '/order/detailList',
      desc: '关联销售订单明细'
    },
    {
      name: 'cancel',
      method: 'POST',
      path: '/cancel',
      desc: '关联销售订单作废'
    },
    {
      name: 'getInvoiceEnum',
      method: 'get',
      path: '/getInvoiceEnum',
      desc: '获取发票类型枚举'
    },
    {
      name: 'logList',
      method: 'get',
      path: '/log/list',
      desc: '获取操作记录'
    },
    {
      name: 'logChangeList',
      method: 'get',
      path: '/log/change/list',
      desc: '获取操作记录'
    },
    {
      name: 'exportDetail',
      method: 'post',
      path: '/exportDetail',
      desc: '导出识别结果'
    },
    {
      name: 'importDetail',
      method: 'post',
      path: '/importDetail',
      desc: '导出识别结果'
    },
    {
      name: 'batchDown',
      method: 'post',
      path: '/batchDown',
      desc: '批量下载'
    },
    {
      name: 'checkError',
      method: 'post',
      path: '/checkError',
      desc: '提交纠错'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/inputInvoice/management.js